// Keep in sync with supabase/functions/_shared/labImport/versioning.ts.
// Coolify builds web/ alone, so this file must not import outside web/.

/**
 * Result versioning (XRPT01 2.12–2.14 / 3.17 / 3.20–3.21 / 3.29;
 * XRPT05 2.5–2.7 / 3.21 / 3.24–3.27):
 * newest ResultsDateTime is current, except a later midlertidigt / proeve_modtaget
 * must not overwrite an endeligt / rettet. History is always kept.
 */

const STATUS_RANK: Record<string, number> = {
  proeve_modtaget: 1,
  svar_midlertidigt: 2,
  svar_endeligt: 3,
  svar_rettet: 4,
};

export function statusRank(code: string | null | undefined): number {
  if (!code) return 0;
  return STATUS_RANK[code] ?? 0;
}

export function isPreliminaryStatus(code: string | null | undefined): boolean {
  return code === 'proeve_modtaget' || code === 'svar_midlertidigt';
}

export function isFinalStatus(code: string | null | undefined): boolean {
  return code === 'svar_endeligt' || code === 'svar_rettet';
}

export function isCorrectedStatus(code: string | null | undefined): boolean {
  return code === 'svar_rettet';
}

export function shouldBecomeCurrent(
  incoming: { resultsDateTime: string | null; resultStatusCode: string | null },
  current: { resultsDateTime: string | null; resultStatusCode: string | null } | null,
): boolean {
  if (!current) return true;
  if (isFinalStatus(current.resultStatusCode) && isPreliminaryStatus(incoming.resultStatusCode)) {
    return false;
  }
  const incomingAt = incoming.resultsDateTime ? Date.parse(incoming.resultsDateTime) : 0;
  const currentAt = current.resultsDateTime ? Date.parse(current.resultsDateTime) : 0;
  if (incomingAt !== currentAt) return incomingAt > currentAt;
  return statusRank(incoming.resultStatusCode) >= statusRank(current.resultStatusCode);
}

export function displayValue(value: string | null, resultStatusCode: string | null): string {
  if (resultStatusCode === 'proeve_modtaget') return '*****';
  return value ?? '';
}
